module.exports = __webpack_public_path__ + "static/media/pinaki.04d9d9af.png";